import IdleJs from 'idle-js';
import * as types from '@/store/mutation-types';

export const init = function (store) {
  var idle = new IdleJs({
    idle: 1000 * 60 * 60,
    onIdle: () => {
      store.commit(types.setLoggedIn, false);
    },
  });
  idle.start();
};



// WEBPACK FOOTER //
// ./src/common/idleguard.js